var map = {
	"./AboutMe.jpg": 5,
	"./GitHub.png": 7,
	"./bossy.png": 21,
	"./covid.png": 22,
	"./employee.png": 23,
	"./imdb.png": 9,
	"./linkedin.png": 8,
	"./linkedin.svg": 24,
	"./password.png": 25,
	"./preview.png": 26,
	"./techblog.png": 27,
	"./weather.png": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;